import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    margin: theme.spacing(3, 0, 2),
  },
  filters: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: 1,
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  tabCount: {
    minWidth: 22,
    padding: theme.spacing(0, 0.75),
    borderRadius: 11,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: '20px',
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.secondary,
  },
  extraTab: {
    marginTop: theme.spacing(3),
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  fullRow: {
    gridColumn: '1 / -1',
  },
  table: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.5),
  },
  ssoNotice: {
    marginBottom: theme.spacing(2),
  },
  // Directory groups are often full LDAP DNs: let them wrap instead of stretching the table.
  groupValueCell: {
    wordBreak: 'break-all',
    maxWidth: 480,
  },
  emptyState: {
    padding: theme.spacing(6),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6),
  },
  modalPaper: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    padding: theme.spacing(3),
  },
  modalActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
  },
  section: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(0.5),
  },
  option: {
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiFormControlLabel-label': {
      paddingTop: theme.spacing(1),
    },
  },
}));
